import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { GraphGroup, GraphProfile } from '@webgate/angular-azure-core';
import { UserService } from 'src/app/services/user.service';

import { UserSearchComponent } from './userselect/user-search.component';

@Component({
  templateUrl: './person-select.component.html',
  styles: ['.dialog { width: 800px; }'],
  imports: [MatButtonModule, MatDialogModule, UserSearchComponent]
})
export class PersonSelectComponent implements OnInit {
  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<PersonSelectComponent>>(MatDialogRef);

  userService = inject(UserService);
  selectedRowsUsers: GraphProfile[] = [];
  selectedRowsGroups: GraphGroup[] = [];

  userSearchTranslations: Record<string, string> = {};
  groupSearchTranslations: Record<string, string> = {};
  dialogTitle = '';
  currentPeople: string[] = [];
  currentGroups: string[] = [];
  singleSelect = false;
  userAndGroupSearch = false;
  searchToggleFG = new FormGroup({ searchToggle: new FormControl(true) });

  ngOnInit(): void {
    this.dialogTitle = this.data.dialogTitle;
    this.currentPeople = this.data.currentPeople || [];
    this.currentGroups = this.data.currentGroups || [];
    this.singleSelect = this.data.singleSelect;
    this.userAndGroupSearch = this.data.userAndGroupSearch;
    this.loadUsers();
  }

  loadUsers(): void {
    this.currentPeople.forEach((userId) => {
      this.userService.getUser(userId).subscribe((user) => {
        if (user) this.selectedRowsUsers.push(user);
      });
    });
  }

  updateRows(event: { groups?: GraphGroup[]; users?: GraphProfile[] }): void {
    this.selectedRowsUsers = event?.users || [];
    this.selectedRowsGroups = event?.groups || [];
  }

  savePeople(): void {
    const closeData = this.singleSelect
      ? { save: true, id: this.selectedRowsUsers[0]?.id }
      : {
          save: true,
          userIds: this.selectedRowsUsers.map((u) => u.id || '') || [],
          groupIds: this.selectedRowsGroups.map((g) => g.id) || []
        };

    this.dialogRef.close(closeData);
  }

  applyDisabled(): boolean {
    const entireSelection = this.selectedRowsUsers.map((u) => u.id).concat(this.selectedRowsGroups.map((g) => g.id));
    return this.singleSelect ? entireSelection.length !== 1 : entireSelection.length < 1;
  }
}
